import { Heading, Text, Icon } from '@livechat/design-system-react-components';

import { Product } from 'constants/product';
import { getProductDisplayName, getProductName } from 'helpers/product';
import { getLogoSource } from 'utils/logo';

import {
  labelStyles,
  productItemStyles,
  productTextContainerStyles,
  headingStyles,
} from './DropdownItems.styles';

interface IProductListItem {
  product: Product;
  label: string;
  url: string;
}

export const ProductListItem = ({ url, product, label }: IProductListItem) => {
  const productName = getProductName(product);

  return (
    <a
      href={url}
      css={productItemStyles}
      data-testid="product-list-item"
      target="_blank"
      rel="noreferrer"
    >
      <Icon source={getLogoSource(productName)} />
      <div css={productTextContainerStyles}>
        <Heading css={headingStyles} size="xs">
          {getProductDisplayName(productName)}
        </Heading>
        <Text css={labelStyles}>{label}</Text>
      </div>
    </a>
  );
};
